import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=900c590c&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"
import style0 from "./forgot.vue?vue&type=style&index=0&id=900c590c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900c590c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
